import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Dropdown from './Dropdown'
import {ReactComponent as IconCloseBlack} from '../../../../assets/icons/ic-close-black.svg'

const PrintSettingModal = ({ handleClose,handleLeadPrint }) => {
    const { t } = useTranslation()
    const [viewType, setViewType] = useState('wave')
    const [format, setFormat] = useState({ label: '3ch(3ch*2.5s) + 1R', value: '3ch(3ch*2.5s) + 1R' })
    const [lead1, setLead1] = useState({ label: 'Ⅱ', value: 'Ⅱ' })

    const formatValueArr = [
        { label: '3ch(3ch*2.5s) + 1R', value: '3ch(3ch*2.5s) + 1R' },
        { label: '6ch(6ch*5s)', value: '6ch(6ch*5s)' },
        { label: '6ch(6ch*5s) + 1R', value: '6ch(6ch*5s) + 1R' },
    ]

    const lead1ValueArr = [
        { label: 'Ⅰ', value: 'Ⅰ' }, { label: 'Ⅱ', value: 'Ⅱ' }, { label: 'Ⅲ', value: 'Ⅲ' },
        { label: 'aVR', value: 'aVR' }, { label: 'aVL', value: 'aVL' }, { label: 'aVF', value: 'aVF' },
        { label: 'V1', value: 'V1' }, { label: 'V2', value: 'V2' }, { label: 'V3', value: 'V3' },
        { label: 'V4', value: 'V4' }, { label: 'V5', value: 'V5' }, { label: 'V6', value: 'V6' },
    ]

    const [dropdownStates, setDropdownStates] = useState({
        format: false,
        lead1: false,
    });

    const handleClickDropdown = (type, val) => {
        setDropdownStates(prev => ({
            ...prev,
            [type]: typeof val !== 'undefined' ? false : !prev[type],
        }));
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50" style={{ zIndex: 10001 }}>
            <div className="w-[360px] h-[317px] bg-[#DEDEDE]" style={{ left: 500, borderRadius: 8, boxShadow: '0px 12px 12px 0px #00000099', zIndex: 5 }}>
                <div className="flex items-center bg-[#CECECE] h-[38px]" style={{ padding: '10px 20px', borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>
                    <span className="text-black" style={{ fontSize: 16, fontWeight: 400, lineHeight: '17.6px' }}>{t('leadModal.printSettingTitle')}</span>
                    <IconCloseBlack className="ml-auto cursor-pointer" style={{ marginRight: -8 }} onClick={() => { handleClose() }}/>
                </div>
                <div className="w-full flex flex-col gap-[20px]" style={{ paddingTop: 20, paddingLeft: 20, paddingRight: 20 }}>
                    <div className="flex flex-col gap-[6px]">
                        <div className="text-[#444444]" style={{ lineHeight: '15.4px' }}>{t('leadModal.viewType')}</div>
                        <div className="flex items-center">
                            <label className="custom-radio flex-1">
                                <input
                                    type="radio"
                                    checked={viewType === 'wave'}
                                    onChange={() => setViewType('wave')}
                                />
                                <span className="font-light" style={{ color: 'black', paddingLeft: 25, fontSize: 16 }}>{t('leadModal.wave')}</span>
                            </label>
                            <label className="custom-radio flex-1">
                                <input
                                    type="radio"
                                    checked={viewType === 'value'}
                                    onChange={() => setViewType('value')}
                                />
                                <span className="font-light" style={{ color: 'black', paddingLeft: 25, fontSize: 16 }}>{t('leadModal.values')}</span>
                            </label>
                        </div>
                    </div>
                    <div className="flex flex-col gap-[6px]" style={{ opacity: viewType === 'value' ? 0.5 : 1 }}>
                        <div className="text-[#444444]" style={{ lineHeight: '15.4px' }}>{t('leadModal.format')}</div>
                        <Dropdown
                            customWidth={320}
                            type={'view-format'}
                            isShow={dropdownStates.format}
                            value={format}
                            valueArr={formatValueArr}
                            handleClick={(val) => { if (viewType !== 'value') handleClickDropdown('format', val) }}
                            handleValueClick={(val) => { setFormat(val) }}
                        />
                    </div>
                    <div className="flex flex-col gap-[6px]" style={{ opacity: (viewType === 'value' || format.value === '6ch(6ch*5s)') ? 0.5 : 1 }}>
                        <div className="text-[#444444]" style={{ lineHeight: '15.4px' }}>{t('leadModal.rhythmLead1')}</div>
                        <Dropdown
                            customWidth={320}
                            type={'view-lead-1'}
                            isShow={dropdownStates.lead1}
                            value={lead1}
                            valueArr={lead1ValueArr}
                            handleClick={(val) => { if (viewType !== 'value' && format.value !== '6ch(6ch*5s)') handleClickDropdown('lead1', val) }}
                            handleValueClick={(val) => { setLead1(val) }}
                        />
                    </div>
                </div>
                <div className="flex justify-end gap-[8px]" style={{ paddingRight: 20, marginTop: 20 }}>
                    <div onClick={() => { handleClose() }} className="flex justify-center items-center cursor-pointer w-[88px] h-[28px] bg-gradient-to-b from-[#FFFFFF] to-[#DEDEDE] rounded-[6px] font-light" style={{ fontSize: 16, border: '1px solid', borderImageSource: 'linear-gradient(180deg, #B8B8B8 0%, #B0B0B0 100%)' }}>{t('leadModal.cancel')}</div>
                    <div onClick={() => { handleLeadPrint(viewType,format,lead1) }} className="flex justify-center cursor-pointer items-center w-[88px] h-[28px] rounded-[6px] bg-gradient-to-b from-[#5E5E5E] to-[#383838] text-white font-light" style={{ fontSize: 16, border: '1px solid #5E5E5E' }}>{t('leadModal.print')}</div>
                </div>
            </div>
        </div>
    )

}

export default PrintSettingModal